import { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export const ClinicContext = createContext();

export const ClinicProvider = ({ children }) => {
    const [clinic, setClinic] = useState(() => {
        try {
            const stored = sessionStorage.getItem('clinic');
            return stored ? JSON.parse(stored) : null;
        } catch {
            sessionStorage.removeItem('clinic');
            return null;
        }
    });

    useEffect(() => {
        if (clinic) {
            sessionStorage.setItem('clinic', JSON.stringify(clinic));
        } else {
            sessionStorage.removeItem('clinic');
        }
    }, [clinic]);

    return (
        <ClinicContext.Provider value={{ clinic, setClinic }}>
            {children}
        </ClinicContext.Provider>
    );
};

export const useClinic = () => useContext(ClinicContext);

ClinicProvider.propTypes = {
    children: PropTypes.node.isRequired
};
